import { render } from "./DeleteLegalModal.vue?vue&type=template&id=639ab868"
import script from "./DeleteLegalModal.vue?vue&type=script&lang=js"
export * from "./DeleteLegalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__